import axios from "@/modules/shared/AxiosInterceptor"
import { GetWebhookLogsFilters, IWebhookLog } from "@/types/webhooks.types"
import { getDateTimeMillis } from "@/utils/datetime"
import { AxiosResponse } from "axios"
import { isEmpty } from "lodash"

export async function getWebhooks() {
  return axios
    .get("/webhooks/")
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

export interface IGetWebhookLogsResponse {
  logs: IWebhookLog[]
  metadata: {
    total: number
  }
}

const buildWebhookLogsQueryString = (p: GetWebhookLogsFilters) => {
  if (isEmpty(p)) {
    return ""
  }

  const limit = p.limit !== undefined ? `&limit=${p.limit}` : ""

  const offset = p.offset !== undefined ? `&offset=${p.offset}` : ""

  const _from = getDateTimeMillis(p.dates?.range?.[0] || "", p?.dates?.format!)
  const _to = getDateTimeMillis(p.dates?.range?.[1] || "", p?.dates?.format!, true)
  const to = _to !== undefined ? `&to=${_to}` : ""
  const from = _from !== undefined ? `&from=${_from}` : ""

  const order_id = p.order_id !== undefined ? `&order_id=${p.order_id}` : ""

  const event_id = p.event_id !== undefined ? `&event_id=${p.event_id}` : ""

  return `${limit}${offset}${to}${from}${order_id}${event_id}`
}

export async function getWebhookLogs(
  id: string,
  p: GetWebhookLogsFilters
): Promise<AxiosResponse<IGetWebhookLogsResponse>> {
  const queryString = buildWebhookLogsQueryString(p)
  return axios
    .get(`/webhooks/${id}/logs/v2?${queryString}`)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

export async function testWebhook(createWebhookPayload: { url: string }) {
  return axios
    .post("/webhooks/test", createWebhookPayload)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

export async function postWebhook(createWebhookPayload: { url: string }) {
  return axios
    .post("/webhooks/", createWebhookPayload)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

export async function patchWebhook(
  id: string,
  updateWebhookPayload: {
    url: string
  }
) {
  return axios
    .patch(`/webhooks/${id}`, updateWebhookPayload)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}

export async function deleteWebhook(id: string) {
  return axios
    .delete(`/webhooks/${id}`)
    .then((response) => response)
    .catch((error) => {
      throw error
    })
}
